"use strict";
var core_1 = require('@angular/core');
var signature_pad_1 = require('./signature-pad');
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('./signature-pad');
var SignaturePadModule = (function () {
    function SignaturePadModule() {
    }
    /** @nocollapse */
    SignaturePadModule.ctorParameters = [];
SignaturePadModule.ɵfac = function SignaturePadModule_Factory(t) { return new (t || SignaturePadModule)(); };
SignaturePadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SignaturePadModule });
SignaturePadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SignaturePadModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [],
                declarations: [signature_pad_1.SignaturePad],
                exports: [signature_pad_1.SignaturePad]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SignaturePadModule, { declarations: [ɵngcc1.SignaturePad], exports: [ɵngcc1.SignaturePad] }); })();
    return SignaturePadModule;
}());
exports.SignaturePadModule = SignaturePadModule;
exports.SignaturePad = ɵngcc1.SignaturePad;
